import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';
  const currentYear = new Date().getFullYear();
  
  const scrollToSection = (sectionId) => {
    if (!isHomePage) {
      navigate(`/#${sectionId}`);
      return;
    }

    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-brand">
          <span className="footer-icon">&gt;_</span>
          <span className="footer-text">Leviathan</span>
        </div>
        <p className="footer-tagline">Web Development & Digital Systems</p>
        <p className="footer-description">
          North West England–based development studio for businesses seeking scalable, bespoke digital solutions.
        </p>

        <div className="footer-social" aria-label="Social links">
          <a
            className="footer-social-link"
            href="https://www.linkedin.com/in/MarvTurner-Leviathan"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit Leviathan Coding Systems on LinkedIn"
          >
            <span className="footer-social-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" role="img" focusable="false">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.941v5.665H9.351V9h3.414v1.561h.049c.476-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 1 1 0-4.124 2.062 2.062 0 0 1 0 4.124zM7.119 20.452H3.555V9h3.564v11.452z" />
              </svg>
            </span>
            <span>LinkedIn</span>
          </a>
          <a
            className="footer-social-link"
            href="https://www.instagram.com/leviathancodingsystems/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit Leviathan Coding Systems on Instagram"
          >
            <span className="footer-social-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" role="img" focusable="false">
                <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2zm0 1.9A3.85 3.85 0 0 0 3.9 7.75v8.5a3.85 3.85 0 0 0 3.85 3.85h8.5a3.85 3.85 0 0 0 3.85-3.85v-8.5a3.85 3.85 0 0 0-3.85-3.85h-8.5z" />
                <path d="M12 7.3A4.7 4.7 0 1 1 7.3 12 4.7 4.7 0 0 1 12 7.3zm0 1.9A2.8 2.8 0 1 0 14.8 12 2.8 2.8 0 0 0 12 9.2z" />
                <circle cx="17.25" cy="6.75" r="1.15" />
              </svg>
            </span>
            <span>Instagram</span>
          </a>
        </div>
        
        <nav className="footer-nav" aria-label="Footer navigation">
          <div className="footer-nav-group">
            <h4>Services</h4>
            <button onClick={() => scrollToSection('services')} className="footer-nav-link">What We Build</button>
            <button onClick={() => scrollToSection('pricing')} className="footer-nav-link">Pricing</button>
          </div>
          <div className="footer-nav-group">
            <h4>Company</h4>
            <button onClick={() => scrollToSection('about')} className="footer-nav-link">About</button>
            <button onClick={() => scrollToSection('faq')} className="footer-nav-link">FAQs</button>
            <Link to="/web-developer-widnes" className="footer-nav-link">Web Developer Widnes</Link>
            <Link to="/digital-growth" className="footer-nav-link">Digital Growth</Link>
          </div>
          <div className="footer-nav-group">
            <h4>Legal</h4>
            <Link to="/privacy" className="footer-nav-link">Privacy</Link>
          </div>
        </nav>
        
        <div className="footer-contact">
          <h4>Ready to start?</h4>
          <button onClick={() => scrollToSection('contact')} className="footer-link">
            Start a Project
          </button>
        </div>
        
        <p className="footer-copyright">
          © {currentYear} Leviathan Coding Systems. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
